import { createRouteRef } from '@backstage/core-plugin-api';

export const entityRouteRef = createRouteRef({
  id: 'appfolio.deployments.entity',
});

export const rootRouteRef = createRouteRef({
  id: 'appfolio.deployments.root',
});

export const cdepRouteRef = createRouteRef({
  id: 'appfolio.cdep.root',
});
